export default "__VITE_ASSET__DmWI0s8Y__"